import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../firebase';
// import { getUserData } from '../services/stripeService';

const UserContext = createContext();

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Safety check: if auth is not initialized, just set loading to false
    if (!auth) {
      setLoading(false);
      return;
    }

    const unsubscribe = auth.onAuthStateChanged(async (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
        
        // Commented out: Stripe subscription data fetching
        // try {
        //   // Get user data from API (which reads from Firestore)
        //   const userDoc = await getUserData();
        //   setUserData(userDoc);
        // } catch (error) {
        //   console.error('Error fetching user data:', error);
        //   setUserData(null);
        // }
        setUserData(null); // Set to null since we're not fetching subscription data
      } else {
        setUser(null);
        setUserData(null);
      }
      
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const value = {
    user,
    userData,
    loading,
    setUserData
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};
